import { Calendar, CircleDollarSign, Clock, Gauge, Zap } from 'lucide-react';
import type { StatStripCell } from '../../../components/ui/StatStrip.js';
import { type DebugPayload, formatCost, formatDateShort, formatDuration, humanizeStatus } from './run-detail-types.js';

const capitalize = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);

/** The run's headline numbers for the StatStrip (demo page /ai). Trajectory is not in the debugger payload, so it is not shown. */
export function runStatCells(run: DebugPayload['run']): StatStripCell[] {
  const severity = run.status === 'failed' ? 'danger' : run.status === 'running' ? 'accent' : undefined;
  return [
    { label: 'Status', value: capitalize(humanizeStatus(run.status)), icon: Gauge, severity },
    { label: 'Duration', value: formatDuration(run.durationMs), icon: Clock },
    { label: 'Cost', value: formatCost(run.totalCostUsd), icon: CircleDollarSign },
    { label: 'Started', value: formatDateShort(run.startedAt), icon: Calendar },
    { label: 'Triggered by', value: capitalize(run.triggeredBy ?? '—'), icon: Zap },
  ];
}
